/**
 * @generated SignedSource<<2d8c2e5eaa8c47fc8040cb23bac728d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NotionPageSelectSearchPagesQuery$variables = {
  query: string;
};
export type NotionPageSelectSearchPagesQuery$data = {
  readonly viewer: {
    readonly notionSearch: ReadonlyArray<{
      readonly id: string;
      readonly isDb: boolean;
      readonly label: string;
    }>;
  };
};
export type NotionPageSelectSearchPagesQuery = {
  response: NotionPageSelectSearchPagesQuery$data;
  variables: NotionPageSelectSearchPagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "text",
      "variableName": "query"
    }
  ],
  "concreteType": "NotionPageNode",
  "kind": "LinkedField",
  "name": "notionSearch",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDb",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotionPageSelectSearchPagesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotionPageSelectSearchPagesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be47a082c203de48d37af22942212191",
    "id": null,
    "metadata": {},
    "name": "NotionPageSelectSearchPagesQuery",
    "operationKind": "query",
    "text": "query NotionPageSelectSearchPagesQuery(\n  $query: String!\n) {\n  viewer {\n    notionSearch(text: $query) {\n      id\n      label\n      isDb\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f109dfc56361c1797ee7acd6891dfa2";

export default node;
